import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ServicesFinalCta() {
    return (
        <section className="border-t border-cream-edge bg-[linear-gradient(180deg,var(--color-cream-warm)_0%,var(--color-cream)_100%)] py-20 text-center">
            <div className="container mx-auto max-w-3xl px-4">
                <span className="mb-3 text-[#b20303] inline-block text-xs font-bold tracking-[0.18em] text-accent uppercase">
                    Prêt à commencer ?
                </span>

                <h2 className="mb-3 font-serif text-[clamp(1.75rem,3vw,2.25rem)] leading-tight font-semibold tracking-[-0.015em] text-ink">
                    Obtenez votre première fiche entreprise en quelques secondes.
                </h2>

                <p className="mx-auto mb-7 max-w-xl text-base text-ink-soft">
                    Saisissez un nom de société ou un numéro d&apos;identification
                    pour retrouver les informations disponibles sur une entreprise
                    suisse.
                </p>

               <Link
    to="/recherche-fiche"
    className="inline-flex items-center gap-2 rounded-xl bg-[#b20303] px-7 py-4 text-base font-semibold text-white shadow-[0_8px_22px_rgba(178,3,3,0.30)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#950202] hover:shadow-[0_12px_30px_rgba(178,3,3,0.40)]"
>
    Rechercher une entreprise

    <ArrowRight
        className="h-[18px] w-[18px] transition-transform duration-300 group-hover:translate-x-1"
        strokeWidth={2.4}
    />
</Link>
            </div>
        </section>
    );
}